import { z } from "zod";

/**
 * "Company was on other lists" (PREC-2750): the other lists of the same workspace that hold at
 * least one ADDED lead of this lead's company. The company is identified by
 * `prospect.organizationId` only, so a lead without an organization has no value (`null`) —
 * "we cannot tell", which is not the same answer as an empty array ("on no other list").
 */
export const companyOtherListSchema = z.object({
	listId: z.number(),
	listName: z.string(),
	/** How many ADDED leads of the company that list holds. */
	leadCount: z.number(),
});

export type CompanyOtherList = z.infer<typeof companyOtherListSchema>;

/**
 * Sort sentinel for the list table. It is not a column: the API resolves it to the number of
 * other lists the lead's company is on (`ListProspectQueryBuilder.getSortedBy`).
 */
export const COMPANY_OTHER_LISTS_SORT_KEY = "companyOtherLists";

/**
 * The lead-list filter "Company is on other list" (PREC-4447): the filter's name, which is also the
 * `filterByProperty` key its list picker asks for, and the filterParam the API answers it by. The
 * param names no real column; `applyCompanyOtherListsFilter` claims it before the generic families.
 */
export const COMPANY_OTHER_LIST_FILTER_NAME = "companyOtherList";
export const COMPANY_OTHER_LIST_FILTER_PARAM = "company_other_lists.listId";
